import { isPlatformBrowser } from '@angular/common';
import { Injectable, LOCALE_ID, PLATFORM_ID, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private localeId = inject(LOCALE_ID);
  private platformId = inject(PLATFORM_ID);

  getCurrentLocale(): string {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('app_locale');
      if (saved === 'ar' || saved === 'en') {
        return saved;
      }
      const path = window.location.pathname;
      console.log('path: ', path);
      if (path.startsWith('/ar')) return 'ar';
      if (path.startsWith('/en')) return 'en';
    }
    return this.localeId;
  }

  toggleLocale() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const currentLocale = this.getCurrentLocale();
    const targetLocale = currentLocale === 'en' ? 'ar' : 'en';
    localStorage.setItem('app_locale', targetLocale);
    const path = window.location.pathname;
    const search = window.location.search;
    const hash = window.location.hash;
    let newPath: string;
    if (path.startsWith(`/${currentLocale}/`)) {
      newPath = path.replace(`/${currentLocale}/`, `/${targetLocale}/`);
    } else if (path == `/${currentLocale}`) {
      newPath = `/${targetLocale}`;
    } else if (path == '/' || (!path.startsWith('/en') && !path.startsWith('/ar'))) {
      newPath = `/${targetLocale}${path}`;
    } else {
      newPath = `/${targetLocale}/`;
    }
    window.location.href = newPath + search + hash;
  }

  initLocale() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const saved = localStorage.getItem('app_locale');
    const current = this.getCurrentLocale();
    if (!saved) {
      localStorage.setItem('app_locale', current);
    }
  }
}
